import React from 'react';

const Radio = ({ radios, selected, onChange, checked }) => {

  function handleChange(item) {
    if (item.value !== selected.value) {
      onChange(item)
    }
  }

	return (
    <div className="checkbox">
      { radios && radios.map((item, index) => {
        return (
          <label key={index}>
            <input 
              type="radio"
              onChange={(e) => {
                e.preventDefault();
                handleChange(item);
              }}
              checked={checked(item)} 
            />
            <i></i><span>{item.label}</span>
          </label>
        )})
      }
    </div>
  );
}

export default Radio;
